import React from "react";

import type { MarkdownExtension, MarkdownExtensionNode } from "@/types";

export interface XGroupWebReference {
  url: string;
  title: string;
  snippet: string;
  label: string;
}

export const XGROUP_WEB_REFERENCE_ATTRIBUTES = [
  "url",
  "title",
  "snippet",
] as const;

export const parseXGroupWebReference = ({
  attributes,
  text,
}: Pick<MarkdownExtensionNode, "attributes" | "text">): XGroupWebReference => ({
  url: attributes.url?.trim() || "",
  title: attributes.title?.trim() || "",
  snippet: attributes.snippet?.trim() || "",
  label: text.trim(),
});

const renderStaticWebReference = (node: MarkdownExtensionNode) => {
  const reference = parseXGroupWebReference(node);
  return (
    <span
      aria-label={`外部搜索引用 ${reference.label || "引"}`}
      data-xadk-web-reference="true"
      style={{
        boxSizing: "border-box",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 18,
        height: 18,
        margin: "0 3px",
        padding: "0 5px",
        border: "1px solid #e4e6eb",
        borderRadius: 9,
        background: "#f1f2f4",
        color: "#8a8f99",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: "18px",
        verticalAlign: "1px",
      }}
    >
      {reference.label || "引"}
    </span>
  );
};

export const xGroupWebReferenceMarkdownExtension: MarkdownExtension = {
  tagName: "ai-web-ref",
  allowedAttributes: XGROUP_WEB_REFERENCE_ATTRIBUTES,
  render: renderStaticWebReference,
};
